<form [formGroup]="form">
  <app-icon name="search" size="sm" class="dark"></app-icon>
  <input formControlName="search" autofocus type="search" placeholder="Search..." />
</form>
